module.exports = __webpack_public_path__ + "img/foot_2.f0e724dc.png";